 const Text = {
    DAILY_LIMIT_FREESUBSCRIBER : "Daily Withdrawal Limit: 20 MNT",
    DAILY_LIMIT_PAIDSUBSCRIBER : "Daily Withdrawal Limit: 1500 MNT",
    WITHDRAWAL_NOTE : "Note: Withdrawal requests will be approved at 12 PM and 7 PM Everyday.",
    Connect_Wallet : "Connect Wallet"
  };

export default Text